import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * ログイン用クラス
 */
@JsonObject('LoginParam')
export default class LoginParam {
  constructor() {
    this.userId = undefined;
    this.password = undefined;
    this.returnPath = undefined;
    this.currentCartCode = undefined;
  }

  @JsonProperty('user_id')
  public userId?: string;

  @JsonProperty('password')
  public password?: string;

  @JsonProperty('return_path', null, true)
  public returnPath?: string;

  @JsonProperty('current_cart_code')
  public currentCartCode?: string;
}
